export const T = {
  en_GB: {
    riskScore: "Risk Score",
    riskScoreCannotChange: "Risk score cannot be changed after creation",
    riskScorePlaceholder: "Select a risk score",
    noAvailableScores: "The assigned risk model has no matrix scores.",
  },
  nb_NO: {
    riskScore: "Risikoskår",
    riskScoreCannotChange: "Risikoskår kan ikke endres etter opprettelse",
    riskScorePlaceholder: "Velg en risikoskår",
    noAvailableScores: "Den tilknyttede risikomodellen har ingen matriseskårer.",
  },
} as const;
